<template>
  <b-modal
    :id="id"
    ref="the-modal"
    title-tag="div"
    :ok-title="trans(!result ? 'apply' : 'insert')"
    :cancel-title="trans('cancel')"
    @shown="onShown"
    @hidden="onHidden"
    @ok="onOk"
    :ok-disabled="busy || removeRobot"
  >
    <template #modal-title>
      <h5 class="mb-0">{{ trans('ai_robot') }}</h5>
      <small class="d-block text-muted"><small>{{ trans('ai_powered_by') }}</small></small>
    </template>

    <template #modal-footer>
      <b-row class="w-100 justify-content-end">
        <b-col class="col-auto">
          <b-button variant="secondary" @click="$bvModal.hide(id)">
            {{ trans('cancel') }}
          </b-button>
          <b-button variant="light" @click="onReplace" v-if="result">
            {{ trans('replace') }}
          </b-button>
          <b-button variant="primary" @click="onOk" :disabled="busy || removeRobot">
            {{ trans(!result ? 'apply' : 'insert') }}
          </b-button>
        </b-col>
      </b-row>
    </template>

    <div v-if="!removeRobot && !result">
      <b-form-group :label="trans('how_assist')">
        <b-form-radio-group
            v-model="selected"
            :options="options"
            stacked
        ></b-form-radio-group>
        <b-form-select v-model="selectedLang" :options="langOptions" class="mt-1" v-if="selected == 'translate'"></b-form-select>

        <div v-if="selected == 'other'" class="mt-2">
            <b-dropdown
                :text="trans('samples')"
                variant="link"
                class="mt-1"
                toggle-class="p-0 btn-sm"
            >
                <b-dropdown-item
                    v-for="sample in sampleMessages"
                    v-bind:key="sample.id"
                    @click="onChooseSample(sample.id)"
                >
                    {{ trans(`${sample.id}_title`) }}
                </b-dropdown-item>
            </b-dropdown>

            <b-textarea v-model="directive" rows="4" style="border-radius: 4px;padding: 5px;" :disabled="busy"></b-textarea>

            <b-form-checkbox
                v-model="include_text"
                class="text-right"
            >
                {{ trans('include_text') }}
            </b-form-checkbox>
        </div>

      </b-form-group>
    </div>

    <div v-if="!busy && !removeRobot && !!result" v-html="result"></div>

    <p v-if="busy">
      <i class="fa fa-fw fa-circle-notch fa-spin"></i>
      {{ `${trans('please_wait')} ${trans('duration_vary')}` }}
    </p>
    <p v-if="!!error" class="text-danger">
      {{ error }}
    </p>
  </b-modal>
</template>

<script>
  export default {
    props: {
      id: {
        type: String,
        default: 'chat-gpt-modal',
      },
      organization: Object,
      initialDirective: {
        type: String,
        default: trans('ai_directive_improve'),
      },
      text: String,
    },
    data() {
      return {
        trans: trans,
        busy: false,
        error: null,
        result: null,
        options: [
          { text: trans('improve_text'), value: 'improve' },
          { text: trans('variants_text'), value: 'variants' },
          { text: trans('translate_text'), value: 'translate' },
          { text: trans('other'), value: 'other' }
        ],
        selected: 'improve',
        directive: this.initialDirective,
        langOptions: [
            { text: trans('fr_to_en'), value: 'en'},
            { text: trans('en_to_fr'), value: 'fr'}
        ],
        selectedLang: window.lang,
        sampleMessages: [
            { id: 'generate_text', textNeeded: false, },
            { id: 'generate_gratitude_text', textNeeded: false },
            { id: 'revise_text', textNeeded: true },
            //{ id: 'provide_different_variations', textNeeded: true },
            { id: 'change_tone', textNeeded: true }
        ],
        include_text: true
      }
    },
    computed: {
      removeRobot() {
        return !!this.text && this.text.indexOf('Robot:') >= 0
      },
    },
    methods: {
      onShown() {
        this.error = this.removeRobot ? trans('ai_remove_robot') : null
      },
      onHidden() {
        this.busy = false
        this.error = null
        this.result = null
      },
      onReplace() {
        this.$emit('replace', this.result)
        this.$bvModal.hide(this.id)
      },
      onOk(e) {
        if (!!this.result) {
          this.$emit('input', `<p>Robot:</p> ${this.result}`)
          this.$bvModal.hide(this.id)
          return
        }

        e.preventDefault()

        this.error = null
        let promt = null

        if (this.selected == 'other') {
            promt = this.directive
            if (this.include_text) {
                promt = `${promt} ${this.text}`
            }
        } else if (this.selected == 'translate') {
            promt = trans(`${this.selected}_ai`, {
                lang: trans(this.selectedLang)
            })
            promt = `${promt} ${this.text}`
        } else {
            promt = `${trans(`${this.selected}_ai`)} ${this.text}`
        }

        this.busy = true
        let url = `/organization/${this.organization.id}/chatgpt`;
        axios.get(url, {
          params: {
            text: promt
          }
        })
        .then(response => {
          this.busy = false
          this.result = response.data.choices[0].message.content
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
      onChooseSample(id) {
        let sample = this.sampleMessages.find(o => o.id == id)
        this.directive = trans(sample.id)
        this.include_text = sample.textNeeded
      }
    },
    mounted() {
      window.chatGptModal = this
    },
  }
</script>
